// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"044d8be5","803":"044d8be5","861":"83367f36","912":"3416088f"}[chunkId] + ".chunk.css";
};